import { store } from 'redux/store';
import { isAuthenticated } from 'utils/auth';
import { apiInterceptor } from 'utils/apiInterceptor';
export async function UpdateNotification(inputs, projectId, notificationId) {
    const user = store?.getState()?.user

    if (isAuthenticated() && user) {
        const response = await apiInterceptor(
            `${process.env.REACT_APP_MYXP_API_NOTIFICATION}/xpmgr/notifications/update/${projectId}/${notificationId}`,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(inputs),
            }
        );
        return await response.json();
    }
}
